import React, {Component} from 'react';
import {connect} from 'react-redux';
import {reduxForm, Field} from 'redux-form';
import {Card, Button, Input, Form, Grid, Icon} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import {PARAMETERS_FORM} from '../../../../common/forms';
import {paths} from '../../../../common/dictionaries/urls';
import {resources, scopes} from '../../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../../common/permissions/validations';
import './editParameter.scss';

class ParametersForm extends Component {
  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.ParametersList,
        scopes.See
      )
    ) {
      this.props.push(paths.AccessDenied);
      return;
    }
    const {selectedParameter} = this.props;
    this.props.deleteParametersData();
    if (selectedParameter) {
      this.props.fetchSystemParameter(selectedParameter);
    }
  }

  onCancelClick() {
    this.props.goBack();
  }

  onSubmit(formValues) {
    const {selectedParameter} = this.props;

    if (selectedParameter) {
      this.props.updateSystemParameter(selectedParameter, formValues);
      return;
    }
    this.props.createSystemParameter(formValues);
  }

  canEdit() {
    // El backend exige Editar para POST/PUT de parámetros; quien solo tiene Visualizar entra a consultar.
    return hasAccessPermission(this.props.permissions, resources.ParametersList, scopes.Edit);
  }

  render() {
    const {handleSubmit, submitting, selectedParameter} = this.props;
    const canEdit = this.canEdit();

    return (
      <Form
        className='edit-parameter-form'
        onSubmit={handleSubmit(this.onSubmit.bind(this))}
        loading={submitting}
      >
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <Icon name='arrow left' onClick={this.onCancelClick.bind(this)} />
              <h2>
                {' '}
                {selectedParameter ? (canEdit ? 'Editar Parámetro' : 'Ver Parámetro') : 'Añadir Parámetro'}
              </h2>
              <div className='title-bar-actions'>
                <Button
                  secondary
                  type='button'
                  onClick={this.onCancelClick.bind(this)}
                  disabled={submitting}
                >
                  Cancelar
                </Button>
                {canEdit && (
                  <Button primary type='submit' disabled={submitting}>
                    Guardar
                  </Button>
                )}
              </div>
            </div>
          </div>
        </Card>
        {this.renderForm()}
      </Form>
    );
  }

  renderForm() {
    return (
      <Card raised fluid>
        <Grid textAlign='left' className='grid-padding-parameter'>
          <Grid.Row>
            <Grid.Column width={3}>
              <h3>Código*</h3>
            </Grid.Column>
            <Grid.Column width={3}>{this.renderCode()}</Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3}>
              <h3>Descripción*</h3>
            </Grid.Column>
            <Grid.Column width={3}>
              <Field
                name='description'
                required
                component={Input}
                className='textBoxDescription'
                maxLength='100'
                type='text'
                onInvalid={(event) => {
                  event.stopPropagation();
                  event.target.setCustomValidity('Por favor, llene este campo');
                }}
                onInput={(event) => {
                  event.stopPropagation();
                  event.target.setCustomValidity('');
                }}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3}>
              <h3>Valor*</h3>
            </Grid.Column>
            <Grid.Column width={3}>
              <Field
                name='value'
                component={Input}
                required
                maxLength='20'
                type='number'
                className='textBoxValue'
                onInvalid={(event) => {
                  event.stopPropagation();
                  event.target.setCustomValidity('Por favor, llene este campo');
                }}
                onInput={(event) => {
                  event.stopPropagation();
                  event.target.setCustomValidity('');
                }}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card>
    );
  }

  renderCode() {
    const {selectedParameter} = this.props;
    if (selectedParameter) {
      return (
        <p>
          <b>{selectedParameter}</b>
        </p>
      );
    }
    return (
      <Field
        name='code'
        component={Input}
        required
        maxLength='50'
        type='text'
        normalize={(value) => value.toUpperCase()}
        onInvalid={(event) => {
          event.stopPropagation();
          event.target.setCustomValidity('Por favor, llene este campo');
        }}
        onInput={(event) => {
          event.stopPropagation();
          event.target.setCustomValidity('');
        }}
      />
    );
  }
}

export {ParametersForm};

const form = reduxForm({
  'form': PARAMETERS_FORM.name,
})(ParametersForm);

const mapStateToProps = (state, ownProps) => {
  return {
    'selectedParameter': ownProps.params.parameterCode,
    'push': ownProps.history.push,
    'list': state.parameters.list,
    'permissions': state.session.permissions,
    'goBack': ownProps.history.goBack,
  };
};

const {
  fetchSystemParameter,
  deleteParametersData,
  updateSystemParameter,
  createSystemParameter,
  withRouter,
} = Actions;

export default withRouter(
  connect(mapStateToProps, {
    fetchSystemParameter,
    deleteParametersData,
    updateSystemParameter,
    createSystemParameter,
  })(form)
);
